import React, { useState, useRef } from "react";
import {
  BiChevronDown,
  BiChevronUp,
  BiFile,
  BiX,
  BiSearch,
  BiFilter,
  BiStar,
  BiTrophy,
} from "react-icons/bi";
import {
  FaChartBar,
  FaChartLine,
  FaTag,
  FaShoppingCart,
  FaDollarSign,
  FaCalendarAlt,
  FaUsers,
  FaClock,
  FaCoffee,
  FaCheckCircle,
  FaUser,
  FaStore,
  FaBox,
  FaInbox,
} from "react-icons/fa";

const RapportsPage = () => {
  const [showViewDropdown, setShowViewDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const [filters, setFilters] = useState({
    search: "",
  });
  const searchInputRef = useRef(null);

  const [selectedCategory, setSelectedCategory] = useState("all");

  // Données statiques des rapports groupés par catégorie
  const reportsData = {
    "Tous les rapports": {
      category: { id: "all", name: "Tous les rapports", count: 44 },
      reports: [],
    },
    Favoris: {
      category: { id: "favoris", name: "Favoris", count: 0 },
      reports: [],
    },
    "Tableaux de bord": {
      category: { id: "tableaux", name: "Tableaux de bord", count: 2 },
      reports: [
        {
          id: 1,
          name: "Tableau de bord des performances",
          description: "Tableau de bord des performances de votre entreprise.",
          icon: "chart",
        },
        {
          id: 2,
          name: "Tableau de bord de la présence en ligne",
          description:
            "Ventes en ligne et performance de la clientèle en ligne.",
          icon: "line",
        },
      ],
    },
    Standard: {
      category: { id: "standard", name: "Standard", count: 44 },
      reports: [
        {
          id: 3,
          name: "Récapitulatif des ventes",
          description:
            "Quantité et montant des ventes, à l'exclusion des ventes de cartes cadeaux.",
          icon: "tag",
        },
        {
          id: 4,
          name: "Liste des ventes",
          description: "Liste complète de toutes les transactions de ventes.",
          icon: "file",
        },
        {
          id: 6,
          name: "Liste des cartes cadeaux",
          description:
            "Liste complète des cartes cadeaux émises et non utilisées.",
          icon: "tag",
        },
        {
          id: 7,
          name: "Liste des abonnements",
          description: "Liste complète des abonnements actifs.",
          icon: "file",
        },
        // {
        //   id: 8,
        //   name: "Liste des paiements anticipés",
        //   description: "Liste complète de tous les paiements anticipés.",
        //   icon: "dollar",
        // },
        {
          id: 10,
          name: "Récapitulatif des rendez-vous",
          description:
            "Aperçu général des habitudes et des tendances en matière de rendez-vous, y compris les annulations et rendez-vous manqués.",
          icon: "calendar",
        },
        {
          id: 12,
          name: "Récapitulatif des rendez-vous annulés et manqués",
          description: "Données sur les rendez-vous annulés et manqués.",
          icon: "calendar",
        },
        {
          id: 13,
          name: "Renseignements sur la liste d'attente",
          description:
            "Vue détaillée des clients inscrits sur la liste d'attente.",
          icon: "calendar",
        },
        // {
        //   id: 14,
        //   name: "Activité liée aux horaires de travail",
        //   description:
        //     "Vue détaillée des heures travaillées, des plages horaires et des feuilles de temps des membres de l'équipe.",
        //   icon: "clock",
        // },
        // {
        //   id: 15,
        //   name: "Activité liée aux pauses",
        //   description: "Vue détaillée des pauses des membres de l'équipe.",
        //   icon: "coffee",
        // },
        // {
        //   id: 16,
        //   name: "Récapitulatif des présences",
        //   description:
        //     "Aperçu de la ponctualité et de la présence des membres de l'équipe pour leurs plages horaires.",
        //   icon: "check",
        // },
        {
          id: 19,
          name: "Récapitulatif financier",
          description:
            "Récapitulatif complet des ventes, paiements et passifs.",
          icon: "dollar",
        },
        {
          id: 21,
          name: "Transactions financière en ligne",
          description: "Aperçu détaillé de toutes les opérations de paiement.",
          icon: "dollar",
        },
        {
          id: 22,
          name: "Transactions financière en boutique",
          description:
            "Aperçu détaillé de toutes les opérations de paiement dans la boutique.",
          icon: "dollar",
        },
        {
          id: 27,
          name: "Résumé des commissions",
          description:
            "Aperçu des commissions gagnées par les membres de l'équipe, par établissements et par articles en vente.",
          icon: "team",
        },
        {
          id: 28,
          name: "Liste des clients",
          description: "Liste complète de tous les clients actifs.",
          icon: "user",
        },
      ],
    },
    Objectifs: {
      category: { id: "objectifs", name: "Objectifs", count: 0 },
      reports: [],
    },
  };

  const categories = [
    { id: "all", name: "Tous les rapports", count: 44 },
    { id: "favoris", name: "Favoris", count: 0 },
    { id: "tableaux", name: "Tableaux de bord", count: 2 },
    { id: "standard", name: "Standard", count: 44 },
    { id: "objectifs", name: "Objectifs", count: 0 },
  ];

  const categoryTabs = [
    "Tous les rapports",
    "Ventes",
    "Finance",
    "Rendez-vous",
    "Équipe",
    "Clients",
    "Inventaire",
  ];

  const [activeTab, setActiveTab] = useState("Tous les rapports");

  const getIconComponent = (iconType) => {
    const iconMap = {
      chart: FaChartBar,
      line: FaChartLine,
      tag: FaTag,
      cart: FaShoppingCart,
      file: BiFile,
      dollar: FaDollarSign,
      calendar: FaCalendarAlt,
      team: FaUsers,
      clock: FaClock,
      coffee: FaCoffee,
      check: FaCheckCircle,
      star: BiStar,
      trophy: BiTrophy,
      user: FaUser,
      shop: FaStore,
      package: FaBox,
      inbox: FaInbox,
    };
    const IconComponent = iconMap[iconType] || BiFile;
    return <IconComponent size={24} className="text-secondary-600" />;
  };

  const filterReports = (reports) => {
    if (!reports) return [];

    return reports.filter((report) => {
      const searchMatch =
        !filters.search ||
        report.name?.toLowerCase().includes(filters.search.toLowerCase()) ||
        report.description
          ?.toLowerCase()
          .includes(filters.search.toLowerCase());

      return searchMatch;
    });
  };

  const getDisplayedReports = () => {
    if (selectedCategory === "all") {
      return reportsData["Standard"].reports;
    } else if (selectedCategory === "tableaux") {
      return reportsData["Tableaux de bord"].reports;
    }
    return [];
  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const handleExport = (type) => {
    console.log("Export:", type);
  };

  const filteredReports = filterReports(getDisplayedReports());

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* En-tête principal */}
        <div className="bg-white border-b border-gray-200 px-6 py-6">
          <div className="flex flex-col lg:flex-row gap-4 w-full lg:justify-between lg:items-start mb-4">
            <div className="flex-1">
              <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-2">
                <h1 className="font-poppins font-semibold text-[18px] text-title">
                  Rapports et analyses
                </h1>
                <span className="bg-gray-100 px-3 py-1 font-nunito text-[14px] text-text font-medium w-fit">
                  44
                </span>
              </div>
              <p className="font-nunito text-[14px] text-text">
                Accédez à tous vos rapports Fresha.{" "}
                <a
                  href="#"
                  className="text-action hover:underline font-nunito text-[14px] font-semibold"
                >
                  En savoir plus
                </a>
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="relative select-none" ref={dropdownRef}>
                <button
                  className="flex items-center justify-between w-full sm:w-auto gap-2 py-2 px-4 border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 transition-colors font-nunito text-[14px] font-semibold text-action"
                  onClick={() => setShowViewDropdown(!showViewDropdown)}
                >
                  <span>Créer par</span>
                  {showViewDropdown ? (
                    <BiChevronUp size={16} />
                  ) : (
                    <BiChevronDown size={16} />
                  )}
                </button>

                {showViewDropdown && (
                  <div className="absolute top-full right-0 mt-1 bg-white border border-gray-200 shadow-lg z-20 w-48">
                    <button
                      className="w-full text-left py-2 px-4 font-nunito text-[14px] text-text hover:bg-gray-50"
                      onClick={() => {
                        handleExport("excel");
                        setShowViewDropdown(false);
                      }}
                    >
                      Excel
                    </button>
                    <button
                      className="w-full text-left py-2 px-4 font-nunito text-[14px] text-text hover:bg-gray-50"
                      onClick={() => {
                        handleExport("csv");
                        setShowViewDropdown(false);
                      }}
                    >
                      CSV
                    </button>
                  </div>
                )}
              </div>
              <button className="flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 font-nunito text-[14px] font-semibold text-action hover:bg-gray-50 transition-colors">
                Catégorie
                <BiFilter size={16} />
              </button>
            </div>
          </div>

          {/* Barre de recherche */}
          <div className="relative mt-4">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <BiSearch size={20} className="text-gray-400" />
            </div>

            <input
              ref={searchInputRef}
              type="text"
              placeholder="Recherchez par nom ou description de rapport"
              value={filters.search}
              onChange={(e) => handleFilterChange("search", e.target.value)}
              className="w-full pl-10 pr-10 py-2.5 border border-gray-300 font-nunito text-[14px] text-text focus:outline-none focus:ring-2 focus:ring-secondary-500 focus:border-transparent"
            />

            {filters.search && (
              <button
                className="absolute inset-y-0 right-0 pr-3 flex items-center hover:bg-gray-100 px-2"
                onClick={() => handleFilterChange("search", "")}
              >
                <BiX size={18} className="text-gray-400" />
              </button>
            )}
          </div>

          {/* Tabs de catégories */}
          {/* <div className="flex gap-2 mt-6 overflow-x-auto pb-2">
            {categoryTabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 font-nunito text-[14px] font-semibold text-action whitespace-nowrap transition-colors ${
                  activeTab === tab
                    ? "bg-gray-900 text-white"
                    : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-300"
                }`}
              >
                {tab}
              </button>
            ))}
          </div> */}
        </div>

        {/* Contenu principal */}
        <div className="flex">
          {/* Sidebar gauche - Catégories - STICKY */}
          {/* <div className="w-64 bg-white border-r border-gray-200">
            <div className="sticky top-0 h-screen overflow-y-auto">
              <div className="p-4">
                <h2 className="font-poppins font-semibold text-[18px] text-title mb-4">
                  Rapports
                </h2>
                <div className="space-y-1">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category.id)}
                      className={`w-full flex justify-between items-center px-3 py-2.5 font-nunito text-[14px] transition-colors ${
                        selectedCategory === category.id
                          ? "bg-gray-100 text-title font-semibold"
                          : "text-text hover:bg-gray-50"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        {category.id === "all" && (
                          <BiFile size={16} className="text-gray-500" />
                        )}
                        {category.id === "favoris" && (
                          <BiStar size={16} className="text-gray-500" />
                        )}
                        {category.id === "tableaux" && (
                          <FaChartBar size={16} className="text-gray-500" />
                        )}
                        {category.id === "standard" && (
                          <BiFile size={16} className="text-gray-500" />
                        )}
                        {category.id === "objectifs" && (
                          <BiTrophy size={16} className="text-gray-500" />
                        )}
                        <span>{category.name}</span>
                      </div>
                      <span className="text-text font-semibold">
                        {category.count}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div> */}

          {/* Contenu principal - Liste des rapports */}
          <div className="flex-1 p-6">
            {filteredReports.length > 0 ? (
              <div className="space-y-3">
                {filteredReports.map((report) => (
                  <div
                    key={report.id}
                    className="flex items-start gap-4 p-4 bg-white border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-secondary-50 flex items-center justify-center">
                      {getIconComponent(report.icon)}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-poppins font-semibold text-[18px] text-title mb-1">
                        {report.name}
                      </h3>
                      <p className="font-nunito text-[14px] text-text leading-relaxed">
                        {report.description}
                      </p>
                    </div>
                    <button className="flex-shrink-0 p-2 hover:bg-gray-100 transition-colors">
                      <BiStar size={20} className="text-gray-400" />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12 bg-white border border-gray-200">
                <p className="font-nunito text-[14px] text-text">
                  Aucun rapport trouvé avec les critères sélectionnés
                </p>
                {filters.search && (
                  <button
                    onClick={() => handleFilterChange("search", "")}
                    className="mt-2 font-nunito text-[14px] font-semibold text-action hover:text-action/80"
                  >
                    Réinitialiser la recherche
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RapportsPage;
